export const NOT_ATTACHED_MESSAGE =
  'Não foi possível anexar o arquivo selecionado. Formatos de arquivos permitidos: JPG/JPEG, PNG, PDF.'
